module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_8004.63df58f7.png";